import {
  BUTTON_SUBMISSION, STASH, MY_ACCOUNT_SETTINGS
} from '../constants';

export const dashboardComponentClickAnalytics = () => {
  window.LIFE_CYCLE_EVENT_BUS.on('dashboard.click', ({ output }) => {
    const component = output?.component || '';
    const subComponent = output?.subComponent || '';

    const DDOEvent = {
      category: {
        primaryCategory: STASH
      },
      eventInfo: {
        eventName: MY_ACCOUNT_SETTINGS
      },
      eventMode: STASH,
      myAccount: {
        settings: `account dashboard: ${component}: ${subComponent}`,
      },
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(DDOEvent);
  });
};

// 7.49.13 Tab Switch: Planning Dashboard and Manage Accounts
export const dashboardTabClickAnalytics = () => {
  window.LIFE_CYCLE_EVENT_BUS.on('dashboard.tab-click', ({ output }) => {
    const tab = output?.tab;
    if (!tab) return;

    const DDOEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: MY_ACCOUNT_SETTINGS
      },
      myAccount: {
        settings: `account dashboard: ${tab} tab click`,
      },
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(DDOEvent);
  });
};
